import { HttpErrorResponse } from '@angular/common/http';
import { Pipe, type PipeTransform } from '@angular/core';

/**
 * This pipe transforms an HttpErrorResponse containing an exception into a string.
 */
@Pipe({
  name: 'error',
  standalone: true,
})
export class ErrorPipe implements PipeTransform {
  transform(value: HttpErrorResponse | any): string {
    if (!value || !value?.error) {
      return '';
    }

    if (!value.error.status || !value.error.detail) {
      return JSON.stringify(value.error);
    }

    return `${value.error.status}: ${value.error.detail}`;
  }
}
